export default {
  CARD_TITLE_MAX_LENGTH: 58,
};
